import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import ActionBar from './components/ActionBar';
import { HostData } from './components/HostData';
import Description from './components/Description';
import Resolution from './components/Resolution';
import References from './components/References';
import Policies from './components/Policies';
import ImpactsTab from './components/ImpactsTab';
import Owner from './components/Owner';
import ExternalId from './components/ExternalId';
import ToggleButtons from 'Screens/Contextualization/Manage/components/ToggleButtons';
import { Wrapper, Fields } from './styled';
import Tags from './components/Tags';
import RiskAndCVE from './components/RiskAndCVE';
import ToolsHistory from './components/ToolsHistory';
import { selectIsFetchingVulnEnrichment, selectVulnDetail, selectTempCVSSVector } from 'store/Manage/selectors';
import { refreshVulnEnrichment, resetCVSS, updateVuln } from 'store/Manage/actions';

const GeneralTab = () => {
  const vulnDetail = useSelector(selectVulnDetail);
  const tempCVSS = useSelector(selectTempCVSSVector);
  const fetchingVulnEnrichment = useSelector(selectIsFetchingVulnEnrichment);
  const refElement = useRef();

  const scrollToReferences = () => refElement.current.scrollIntoView({ behavior: 'smooth' });

  return (
    <Wrapper>
      <ActionBar />
      <HostData />
      <ToggleButtons id="general" />
      <Fields>
        <RiskAndCVE
          scrollToReferences={ scrollToReferences }
          currentVuln={ vulnDetail }
          updateVuln={ updateVuln }
          tempCVSS={ tempCVSS }
          refreshVulnEnrichment={ refreshVulnEnrichment }
          resetCVSS={ resetCVSS }
          entity="vulns"
          fetchingVulnEnrichment={ fetchingVulnEnrichment }
        />
        <Description />
        <Resolution />
        <Tags />
        <References refElement={ refElement } />
        <ImpactsTab />
        <Policies />
        <ExternalId />
        <Owner />
        <ToolsHistory vuln={ vulnDetail } />
      </Fields>
    </Wrapper>
  );
};

export default GeneralTab;
